import axios from 'axios'

export default {
  getBlobData(url) {
    return axios.get(url, {
      responseType: 'blob'
    })
  },
}
